import styled from "styled-components";
import { COLORS } from "../../shared";
import { MEDIA_QUERY } from "../../entities/Common";

export const HeaderStyled = styled.header`
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
  padding-top: 10px;
  padding-bottom: 10px;
  width: 100%;
  transition: box-shadow 0.25s ease-in-out;
  display: flex;
  flex-direction: column;
  position: sticky;
  margin-bottom: 20px;
  left: 0;
  top: 0;
  z-index: 99;
  width: 100%;
  &.sticky {
    background-color: ${COLORS.WHITE};
    box-shadow: 0 4px 44px 0 rgba(0, 0, 0, 0.1);
  }
  .header {
    &-logo {
      height: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    &-right {
      display: flex;
      align-items: center;
    }
  }

  @media (max-width: ${MEDIA_QUERY.MOBILE}) {
    > div {
      flex-wrap: wrap;
    }
    .header {
      &-left {
        width: 100%;
        margin-bottom: 10px;
      }
      &-right {
        width: 100%;
        justify-content: center;
      }
      &-logo {
        justify-content: center;
      }
    }
  }
`;
